/**
 *  List of all brands available.
 */
export var BRANDS = ['safeco', 'liberty', 'cobrand'];